import React, { useState, useContext } from "react";
import { Sidebar, Sidenav, Nav, Dropdown } from "rsuite";
import { AiOutlineMenu } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { ConfiguracaoGlebaContext } from "../../contexts/ConfiguracaoGlebaContext";

import "../Hamburger/Hamburger.css";

function MenuHamburguerAnimado() {
  const [expand, setExpand] = useState(false);

  // O provider só envolve a rota /Home; nas outras telas o contexto não existe.
  // Por isso o "|| {}": fora da Home simplesmente não há programação pendente.
  const { programacaoAlterada } = useContext(ConfiguracaoGlebaContext) || {};

  const handleToggle = () => {
    setExpand(!expand);
  };
  const navigate = useNavigate();

  // Sair da tela com programação não salva perde o trabalho (inclusive o que
  // acabou de ser clonado). Pergunta antes de navegar.
  const irPara = (rota) => {
    if (
      programacaoAlterada &&
      !window.confirm(
        "Você alterou a programação e não salvou. Se sair agora, vai perder as alterações. Deseja continuar?"
      )
    ) {
      return;
    }
    navigate(rota);
  };

  const handleNavigateHome = () => {
    irPara("/home");
  };
  const handleNavigateCadastroInsumos = () => {
    irPara("/CadastroInsumos");
  };
  const handleNavigateGerarRelatorios = () => {
    irPara("/GerarRelatorios");
  };
  const handleNavigateClonarGleba = () => {
    irPara("/ClonarGleba");
  };
  const handleNavigateManutencao = () => {
    irPara("/ManutencaoProgramacao");
  };
  const handleLogout = () => {
    if (
      programacaoAlterada &&
      !window.confirm(
        "Você alterou a programação e não salvou. Se sair agora, vai perder as alterações. Deseja sair mesmo assim?"
      )
    ) {
      return;
    }
    localStorage.removeItem("token");
    navigate("/");
  };
  const handleNavigateCadastroProdutor = () => {
    irPara("/CadastroProdutor");
  };

  return (
    <div className="headerHamburguer">
      <Sidebar
        style={{ display: "flex", flexDirection: "column" }}
        width={200}
        // heigth={1500}
        // collapsible
        expanded={expand}
        onToggle={handleToggle}
      >
        <Sidenav onSelect={() => setExpand(false)}>
          <Sidenav.Body className="headerHamburguer">
            <Nav className="bodyHamburguer">
              <Dropdown
                icon={
                  <>
                    <AiOutlineMenu
                      style={{ fontSize: "45px", color: "white" }}
                      icon="magic"
                    />
                  </>
                }
              >
                <Dropdown.Item
                  onClick={handleNavigateHome}
                  className="itemDropdown"
                >
                  PROGRAMAÇÃO
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={handleNavigateCadastroInsumos}
                  className="itemDropdown"
                >
                  CADASTRO DE INSUMOS
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={handleNavigateCadastroProdutor}
                  className="itemDropdown"
                >
                  CADASTRO GERAL
                </Dropdown.Item>
                <Dropdown.Item
                  className="itemDropdown"
                  onClick={handleNavigateGerarRelatorios}
                >
                  GERAR RELATÓRIOS
                </Dropdown.Item>
                <Dropdown.Item
                  className="itemDropdown"
                  onClick={handleNavigateClonarGleba}
                >
                  CLONAR GLEBA
                </Dropdown.Item>
                <Dropdown.Item
                  className="itemDropdown"
                  onClick={handleNavigateManutencao}
                >
                  MANUTENÇÃO
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={handleLogout}
                  className="itemDropdown"
                >
                  SAIR
                </Dropdown.Item>{" "}
              </Dropdown>
            </Nav>
          </Sidenav.Body>
        </Sidenav>
      </Sidebar>
    </div>
  );
}

export default MenuHamburguerAnimado;
